export default __webpack_public_path__ + "ecb849724aa600ad1e7c8fc56ce3e965.jpg";